import React, {useEffect, useState} from 'react'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {Link} from 'react-router-dom'
import {LoadingData} from '../../../components/LoadingData'
import {useAuth} from '../../modules/auth'
import {deleteClientGroupe, getClientGroupes} from '../../../components/requests'
import Swal from 'sweetalert2'
import {toast} from 'react-toastify'
import {useLocation} from 'react-router'

interface LocationState {
  add: boolean | null
  edit: boolean | null
}

const RemiseListPage = () => {
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<any>([])
  const location = useLocation()
  const lState = location.state as LocationState

  const getRemiseList = () => {
    setLoading(true)
    getClientGroupes().then((response) => {
      if (response?.status === 200 && response?.data) {
        setData(response.data)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    getRemiseList()
  }, [])

  useEffect(() => {
    if (lState?.add === true) {
      toast.success('Ajout effectué avec succès!')
    } else if (lState?.add === false) {
      toast.warning("Erreur lors de l'ajout!")
    }

    if (lState?.edit === true) {
      toast.success('Modification effectuée avec succès!')
    } else if (lState?.edit === false) {
      toast.warning('Erreur lors de la modification!')
    }
  }, [lState])

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        //toast.info('Suppression en cours...')
        deleteClientGroupe(id).then((response) => {
          if (response?.status === 200 && response?.data) {
            toast.success('Suppression effectuée avec succès!')
            // const dataUpdated = data.filter((d) => d.id !== id)
            // setData(dataUpdated)
            getRemiseList()
          } else {
            toast.warning('Erreur lors de la suppression!')
          }
        })
      }
    })
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              {/*{shouldDisplayFonctionnalite(currentUser, 'AJOUTER REMISE GROUPE') && (*/}
              {/*  <div*/}
              {/*    className='card-toolbar'*/}
              {/*    data-bs-toggle='tooltip'*/}
              {/*    data-bs-placement='top'*/}
              {/*    data-bs-trigger='hover'*/}
              {/*    title='Ajouter une remise groupe client'*/}
              {/*  >*/}
              {/*    <Link to={`/remise/groupe/ajouter`} className='btn btn-sm btn-light-primary'>*/}
              {/*      <KTIcon iconName='plus' className='fs-3' />*/}
              {/*      Créer une remise*/}
              {/*    </Link>*/}
              {/*  </div>*/}
              {/*)}*/}
            </div>
            {/* end::Header */}
            {loading ? (
              <LoadingData />
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR REMISE GROUPE') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-160px'>Groupe client</th>
                            <th className='min-w-120px'>Taux remise (%)</th>
                            <th className='min-w-100px'>Frais port offert</th>
                            <th className='min-w-150px'>Sauf</th>
                            <th className='min-w-100px text-center'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {data.length ? (
                            data.map((i) => {
                              return (
                                <tr key={i.id}>
                                  <td>{i.nom}</td>
                                  <td>{i?.remiseGroupeCLient?.tauxRemise}</td>
                                  <td>{i?.remiseGroupeCLient?.fraisPortOffert ? 'Oui' : 'Non'}</td>
                                  <td>
                                    {i?.remiseGroupeCLient?.sauf &&
                                      i.remiseGroupeCLient.sauf.map((s, index) => {
                                        return (index !== 0 ? ', ' : '') + s?.label
                                      })}
                                  </td>
                                  <td>
                                    <div className='d-flex justify-content-end flex-shrink-0'>
                                      {shouldDisplayFonctionnalite(
                                        currentUser,
                                        'MODIFIER REMISE GROUPE'
                                      ) && (
                                        <Link
                                          to={`/remise/groupe/${i.id}/edit`}
                                          state={{remiseId: i.id}}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i className='bi bi-pencil-square fs-2'></i>
                                        </Link>
                                      )}
                                      {shouldDisplayFonctionnalite(
                                        currentUser,
                                        'SUPPRIMER REMISE GROUPE'
                                      ) &&
                                        !i?.isUsed && (
                                          <p
                                            onClick={() => {
                                              handleDelete(i.id)
                                            }}
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          >
                                            <i className='bi bi-trash fs-2'></i>
                                          </p>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={4} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export default RemiseListPage
